import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { FormButtonStyles } from "./FormButtonStyles";
import type { ButtonType, ButtonVariant } from "./FormButtonStyles";

export type FlattenedCssVariables = Record<string, string>;

interface ButtonTypeMap {
  [key: string]: ButtonType;
}

const BUTTON_VARIANT_TYPES: Record<string, ButtonVariant> = {
  default: "default",
  hover: "hover",
};

const BUTTON_TYPE_ACTION_SIDEBAR_VIEW_MAP: ButtonTypeMap = {
  primaryButton: "primary_button",
  secondaryButton: "secondary_button",
};

export const ButtonStyles = () => {
  const [selectedButtonVariant, setSelectedButtonVariant] =
    useState<ButtonVariant>("default");

  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);

  const buttonType = BUTTON_TYPE_ACTION_SIDEBAR_VIEW_MAP[actionSidebarView];

  if (!buttonType) {
    return null;
  }

  return (
    <div className="divide-primary h-full w-[23rem] divide-y">
      <div className="px-6 py-5">
        <div className="bg-tertiary grid w-full grid-cols-2 gap-1 rounded-xl p-1">
          {Object.entries(BUTTON_VARIANT_TYPES).map(([key, variant]) => (
            <button
              key={key}
              type="button"
              className={classNames("w-full rounded-lg px-2 py-1", {
                "bg-primary": selectedButtonVariant === variant,
                "bg-transparent": selectedButtonVariant !== variant,
              })}
              onClick={() => setSelectedButtonVariant(variant)}
            >
              <Typography.LabelSm weight="semibold" color="text-dark">
                {t(`builder_ui.block_type.button_variants.${variant}`)}
              </Typography.LabelSm>
            </button>
          ))}
        </div>
      </div>
      <FormButtonStyles
        buttonType={buttonType}
        buttonVariant={selectedButtonVariant}
      />
    </div>
  );
};
